import { render, staticRenderFns } from "./QuestionStartPreview.vue?vue&type=template&id=4a58a5c6&scoped=true&"
import script from "./QuestionStartPreview.vue?vue&type=script&lang=ts&"
export * from "./QuestionStartPreview.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionStartPreview.vue?vue&type=style&index=0&id=4a58a5c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58a5c6",
  null
  
)

export default component.exports